import HtmlContent from "../panel/elements/dynamic/html-content/htmlContent";

const Texts = function (props) {
  const { texts } = props;

  return texts.map((text, key) => {
    let styles = text.styles;

    if (text.type === 1) {
      return (
        <div className="w-full px-4 pt-4">
          <div className="w-full border-[1.5px] rounded-xl p-3 flex items-start gap-1 border-[#DF4A42] border-solid">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.25 2C5.69378 2 2 5.69378 2 10.25C2 14.8062 5.69378 18.5 10.25 18.5C14.8062 18.5 18.5 14.8062 18.5 10.25C18.5 5.69378 14.8062 2 10.25 2ZM9.39137 4.53846H11.0464V9.13212L10.6441 12.2722H9.9016L9.39105 9.13212V4.53846H9.39137ZM10.2576 15.6442C9.71629 15.6442 9.34504 15.1337 9.34504 14.5305C9.34504 13.8965 9.71629 13.4015 10.2576 13.4015C10.6907 13.4015 11.155 13.8965 11.155 14.5305C11.155 15.1337 10.6907 15.6442 10.2576 15.6442Z"
                fill="#DF4A42"
              />
            </svg>

            <p className="text-start leading-6 text-[#363636] text-sm">
              <span className="!text-[#DF4A42] font-medium inline-block ml-[4px]">
                {text.title ? text.title : "اطلاعیه"} :
              </span>
              {text.data && text.data.value ? (
                <div
                  className={`html-content inline-block [&_p]:hidden`}
                  dangerouslySetInnerHTML={{ __html: text.data.value }}
                />
              ) : (
                "روز پنجشنبه بخش پشتیبانی مجموعه تعطیل است."
              )}
            </p>
          </div>
        </div>
      );
    }

    if (
      styles &&
      styles.backgroundImage &&
      !styles.backgroundImage.includes("url")
    ) {
      styles.backgroundImage = `url(${styles.backgroundImage})`;
    }

    return (
      <p
        key={key}
        style={styles}
        className={text.custom_classes ? text.custom_classes.join(" ") : null}
      >
        <strong>{text.title ? text.title : ""}</strong>
        <br />
        {text.data && text.data.value ? (
          <HtmlContent content={text.data.value} />
        ) : (
          ""
        )}
        {text.image && text.image.original ? (
          <img
            src={text.image.original}
            style={text.image.styles ? text.image.styles : {}}
            alt={text.title}
          />
        ) : (
          ""
        )}
      </p>
    );
  });
};

export default Texts;
